import { render, staticRenderFns } from "./membercard-dialog-selector.vue?vue&type=template&id=527e8b09&"
import script from "./membercard-dialog-selector.vue?vue&type=script&lang=js&"
export * from "./membercard-dialog-selector.vue?vue&type=script&lang=js&"
import style0 from "./membercard-dialog-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports